import {CircularProgress} from "@mui/material";

export const Loading = ({children}) => {
    return (
        <div style={{
            zIndex: 1000000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            top: 0,
            left: 0,
            position: "fixed",
            width: "100%",
            height: "100%",
            background: "#00000088",
            flexDirection: "column",
            gap: 8
        }}>
            {children ? children : <CircularProgress/>}
        </div>
    )
}
